import { render, staticRenderFns } from "./m-feature.vue?vue&type=template&id=6b9cf962&scoped=true&"
import script from "./m-feature.vue?vue&type=script&lang=ts&"
export * from "./m-feature.vue?vue&type=script&lang=ts&"
import style0 from "./m-feature.vue?vue&type=style&index=0&id=6b9cf962&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9cf962",
  null
  
)

export default component.exports